document.addEventListener("DOMContentLoaded", function () {
  let processing = false;
  let nextPageUrl = null;

  function loadMoreProducts() {
    if (!nextPageUrl || processing) return;
    processing = true;
    showSpinner(true);

    fetch(nextPageUrl)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProducts = doc.querySelectorAll('.product-list > *');

        const productList = document.querySelector('.product-list');
        if (!productList || newProducts.length === 0) {
          console.warn("Nenhuma nova .product-list encontrada.");
          showSpinner(false);
          processing = false;
          return;
        }

        productList.append(...newProducts);

        // 💤 Força lazyload para novas imagens
        newProducts.forEach(el => {
          el.querySelectorAll('img').forEach(img => {
            if (!img.hasAttribute('loading')) {
              img.setAttribute('loading', 'lazy');
            }
          });
        });

        // 🧠 Pós-tratamento ocioso
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            // Aqui você pode reinicializar tooltips, popups, etc. se necessário
            console.log("[∞] Produtos adicionados. Reexecutar init?");
          });
        }

        // 🔄 Atualiza próximo link
        const newNextPageLink = doc.querySelector('a[rel="next"]');
        nextPageUrl = newNextPageLink ? newNextPageLink.href : null;

        showSpinner(false);
        if (!nextPageUrl) console.log("[∞] Fim da paginação.");
        processing = false;
      })
      .catch(error => {
        console.error("[∞] Erro ao carregar:", error);
        showSpinner(false);
        processing = false;
      });
  }

  function showSpinner(visible) {
    const spinner = document.getElementById('loadingSpinner');
    if (spinner) {
      spinner.style.display = visible ? 'block' : 'none';
    }
  }

  window.addEventListener('scroll', () => {
    const { scrollTop, clientHeight, scrollHeight } = document.documentElement;
    if (scrollTop + clientHeight >= scrollHeight - 800 && !processing) {
      loadMoreProducts();
    }
  });

  const initialNextPageLink = document.querySelector('a[rel="next"]');
  if (initialNextPageLink) {
    nextPageUrl = initialNextPageLink.href;
    console.log("[∞] Primeira página configurada:", nextPageUrl);
  }
});